import type { LevelDef } from '../level.ts';

// A T of awkward angles; jets arrive.
export const kyoto: LevelDef = {
  id: 'kyoto', city: 'kyoto', country: 'japan',
  blurb: 'sakura drift, a T of awkward angles, the first jets',
  baseline: 185, scoreMul: 1.2,
  capBase: 3, capDiv: 4, capMax: 6,
  spawnLead: [4, 10], minSpawnGap: 1.7, tempo: 1,
  mix: [['light', 0.32], ['medium', 0.32], ['heavy', 0.22], ['jet', 0.14]],
  layout: {
    runways: [
      { x1: -0.60, y1: -0.48, x2: 0.42, y2: -0.48 },
      { x1: 0.15, y1: 0.72, x2: 0.15, y2: -0.06 },
    ],
    pads: [],
  },
  palette: { bg: '#eef3e4', field: '#dee9cd', deep: '#d2e0bf' },
  decor: ['sakura', 'torii'],
  // e4 yo: no third, plain and bright, a short wooden room
  music: { root: 64, mode: 'yo', bpm: 58, wind: 0.4, verb: 0.6, bright: 2600, space: 2.6 },
};
